<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item">
                <router-link to="/kr/findId"> 
                    아이디 찾기
                </router-link>
            </li>
            <li class="tab-menu__item active">
                <router-link to="/kr/findPw">
                    비밀번호 찾기
                </router-link>
            </li>
        </ul>
    </div>
    <div class="find-pw">
        <div class="find-box info">
            <div class="box">
                <div class="box__inner">
                    <h4><span>휴대전화</span> 인증</h4>
                    <div class="box__input">
                        <label>
                            <span>아이디</span>
                            <input type="text" class="input" placeholder="아이디를 입력해 주세요." v-model="pId">
                        </label>
                        <label>
                            <span>휴대전화번호</span>
                            <input type="text" class="input" placeholder="‘_’ 제외하고 입력해 주세요." v-model="phone" @keyup.enter="findPw('phone')" @input="this.$commonUtils.numberOnly">
                        </label>
                    </div>
                    <div class="botton-wrap">
                        <button type="submit" class="main-button c-main" @click="findPw('phone')">임시비밀번호 발급</button>
                    </div>
                </div>
            </div>
            <div class="box">
                <div class="box__inner">
                    <h4><span>이메일</span> 인증</h4>
                    <div class="box__input">
                        <label>
                            <span>아이디</span>
                            <input type="text" class="input" placeholder="아이디를 입력해 주세요." v-model="eId">
                        </label>
                        <label>
                            <span>이메일</span>
                            <input type="text" class="input" placeholder="이메일을 입력해 주세요." v-model="email" @keyup.enter="findPw('email')">
                        </label>
                    </div>
                    <div class="botton-wrap">
                        <button type="submit" class="main-button c-main" @click="findPw('email')">임시비밀번호 발급</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    export default {
        data() {
            return {
                pId: '',
                phone: '',
                eId: '',
                email: '',
            }
        },
        mounted() {

        },
        methods: {
            // 수정필요 휴대전화인증은 어떻게 하는가?(java단)
            findPw(type){
                const param1 = type == 'phone' ? this.pId : this.eId
                const param2 = type == 'phone' ? this.phone : this.email
                if(!param1){
                    alert('아이디를 입력해주시길 바랍니다.')
                    return
                }
                if(!param2){
                    alert(`${type == 'phone' ? '휴대전화번호' : '이메일'}을(를) 입력해주시길 바랍니다.`)
                    return
                }
                const param = {
                    id: param1,
                    ...(type === 'phone' ? { hpNo: param2 } : { email: param2 })
                }

                this.axios.get(this.api.member.findPassword, {params: param})
                .then(res => {
                    const data = res.data
                    alert(data.message)
                    if(data.status){
                        this.$router.push('/kr/login')
                    }
                })
                .catch(err => {
                    alert('오류가 발생했습니다.')
                    location.reload()
                })
            }
        },
    }
</script>
<style>

</style>